<template>
  <v-img :src="urlPortada" :height="imgHeight">
    <v-container class="h100">
      <v-row class="h100" align="end">
        <v-col cols="12" class="py-0">
          <v-container class="py-0 white--text">
            <hr class="my-4" />

            <!-- fecha y botones -->
            <v-row align="center">
              <!-- info del dia -->
              <v-col class="pt-0">
                <div class="text-uppercase caption">
                  {{ hoy.dia + " " + hoy.nombreMes + " " + hoy.anio }}
                </div>
                <div class="headline">{{ hoy.nombreDia }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
import appConfig from "../../mixs/mixAppConfig.js";
import userConfig from "../../mixs/mixUserConfig.js";

export default {
  name: "mdd-portada-libro",
  mixins: [appConfig, userConfig],
  props: ["infooHoy"],
  computed: {
    appSizes() {
      return this.$store.getters["app/sizes"];
    },
    hoy() {
      return {
        anio: this.infooHoy.anio,
        mes: this.infooHoy.mes,
        dia: this.infooHoy.dia,
        nombreDia: this.t.dias[this.infooHoy.diaSem],
        nombreMes: this.t.meses[this.infooHoy.mes]
      };
    },
    imgHeight() {
      return this.$vuetify.breakpoint.height - this.$vuetify.application.top;
    },
    urlPortada() {
      let id = this.userConfig.mdd.por || "1";
      return "/by_use/img/portadas/portada-web-" + id + ".jpg";
    }
  }
};

// <a href="https://www.freepik.es/fotos-vectores-gratis/fondo">Vector de fondo creado por Harryarts - www.freepik.es</a>
</script>

<style>
.firstCap::first-letter {
  text-transform: uppercase;
}
</style>
